import React, { useEffect, useState } from "react";
import DataTable from "../../components/Comman/CustomTable/CommonTable";
import { useDispatch, useSelector } from "react-redux";
import {
  formatDateToCST,
  formatSubmissionValue,
  getIntervalNameById,
} from "../../utils/comman";
import { submissionListAction } from "../../actions/user";
import { Space } from "antd";
import { MailOutlined } from "@ant-design/icons";

const UserDataEntries = () => {
  const dispatch = useDispatch<any>();
  const [loading, setLoading] = useState<boolean>(true);
  const [data, setData] = useState<any[]>([]);
  const handleRefresh = useSelector(
    (state: any) => state?.General?.updateListing
  );
  const [sortConfig, setSortConfig] = useState<{
    field: string | null;
    order: "asc" | "desc" | null;
  }>({
    field: null,
    order: null,
  });
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
  });

  // Fetches the list of organizations with optional query parameters
  const fetchSubmissionList = (params = {}) => {
    setLoading(true); // Show loading indicator before making the API call
    const requestParams = {
      params,
    };
    dispatch(
      submissionListAction(requestParams, (resp: any) => {
        setLoading(false); // Hide loading indicator once the API call is completed
        if (resp?.status === 200) {
          setData(resp?.data || []); // Store the fetched organization data

          // Update pagination state based on API response
          setPagination({
            ...pagination,
            total: resp.pagination?.totalItems,
            current: resp.pagination?.currentPage,
            pageSize: resp.pagination?.pageSize,
          });
        }
      })
    );
  };

  // useEffect to trigger API call when pagination state changes
  useEffect(() => {
    fetchSubmissionList({
      page: pagination.current || 1,
      limit: pagination.pageSize || 10,
    });
  }, [handleRefresh]); // Dependency array ensures function re-runs on pagination updates

  const handleTableChange = (pagination: any, filters: any, sorter: any) => {
    let newSortConfig = { ...sortConfig };
    if (sorter && Object.keys(sorter).length > 0) {
      newSortConfig = {
        field: sorter.field,
        order: sorter.order === "ascend" ? "asc" : "desc",
      };
    }
    setSortConfig(newSortConfig);
    fetchSubmissionList({
      page: pagination.current || 1,
      limit: pagination.pageSize || 10,
      ...(newSortConfig.field && newSortConfig.order
        ? {
            sort: newSortConfig.field,
            order: newSortConfig.order,
          }
        : {}),
    });
  };

  const columns = [
    {
      title: "Org",
      dataIndex: "organization",
      key: "organizationName",
      render: (_, data) => data?.organization?.shortCode || "-",
      sorter: true,
    },
    {
      title: "DE",
      dataIndex: "dataElement",
      key: "dataElement.id",
      render: (dataElement: any) => dataElement?.DataElements_Name,
      sorter: true,
    },
    {
      title: "Category",
      dataIndex: "category",
      key: "category",
      render: (_: any, record: any) =>
        record?.dataElement?.category?.name || "-",
      sorter: true,
    },
    {
      title: "Submission Data Year",
      dataIndex: "SubmissionData_Year",
      key: "SubmissionData_Year",
    },
    {
      title: "Submission Data Period",
      dataIndex: "SubmissionData_Period",
      key: "SubmissionData_Period",
      render: (_, record) =>
        record.SubmissionData_Period
          ? `${record.SubmissionData_IntervalType} ${
              record.SubmissionData_Period || "N/A"
            }`
          : "-",
    },
    {
      title: "Submission Data Value",
      dataIndex: "SubmissionData_Value",
      key: "SubmissionData_Value",
      render: (value: string, record: any) => (
        <div className="text-right">
          {formatSubmissionValue(
            value,
            record?.dataElement?.DataElements_DataType
          )}
        </div>
      ),
    },
    {
      title: "Submission On",
      dataIndex: "SubmissionData_Updated",
      key: "SubmissionData_Updated",
      render: (value) => formatDateToCST(value),
    },
    {
      title: "Updated By",
      dataIndex: "updatedBy",
      key: "updatedBy.id",
      render: (updatedBy: any) => updatedBy?.name || "-",
    },
    {
      title: "Action",
      key: "action",
      render: () => (
        <Space size="middle">
          <span
            style={{ color: "#3DA57F", fontWeight: "bold", fontSize: "16px" }}
          >
            <MailOutlined />
          </span>
        </Space>
      ),
    },
  ];

  return (
    <div>
      {/* <Header /> */}

      <div className="flex justify-between">
        <h1 className="text-3xl font-bold text-left mb-6 text-white">
          My Data Elements Submission
        </h1>
      </div>

      <div className="table-col">
        <DataTable
          columns={columns}
          data={data}
          loading={loading}
          rowKey="id"
          pagination={{
            current: pagination.current,
            pageSize: pagination.pageSize,
            total: pagination.total,
          }}
          onTableChange={handleTableChange}
        />
      </div>
    </div>
  );
};

export default UserDataEntries;
